module.exports = __webpack_public_path__ + "static/media/sy.3c2655e9.svg";